<template>
  <div>
    <section class="innerPage myaccount">
      <div class="container">
        <div class="breadcrumbWrap">
          <div class="breadcrumb">
            <span property="itemListElement" typeof="ListItem">
              <a
                property="item"
                typeof="WebPage"
                title="Go to Jasper Morris Inside Burgundy."
                href="#/"
                class="home"
              >
                <span property="name">首页</span>
              </a>
              <meta property="position" content="1">
            </span> /
            <span property="itemListElement" typeof="ListItem">
              <span property="name">忘记密码</span>
              <meta property="position" content="2">
            </span>
          </div>
        </div>
        <div style="width: 100%; background: rgb(247, 247, 247);">
          <div class="subscribeBottomForm animate fadeInUp triggeredCSS3" style="margin: 0px auto;">
            <form
              class="wppb-user-forms wppb-register-user wppb-user-logged-out"
            >
              <ul>
                <li class="wppb-form-field wppb-default-name-heading">
                  <h4></h4>
                  <span class="wppb-description-delimiter"></span>
                </li>
                <li class="wppb-form-field wppb-default-last-name">
                  <label for="last_name">手机号码</label>
                  <input
                    name="last_name"
                    id="last_name"
                    maxlength="70"
                    type="text"
                    v-model="phone"
                    class="text-input default_field_lastname"
                  >
                </li>
                <li class="wppb-form-field wppb-default-username">
                  <label for="username">
                    验证码
                    <span title="This field is required" class="wppb-required">*</span>
                  </label>
                  <input
                    name="username"
                    id="username"
                    maxlength="70"
                    type="text"
                    v-model="vcode"
                    required="required"
                    class="text-input default_field_username"
                  >
                  <div
                    style="text-align: center; width: 480px; height: 56px; margin-left: 126px; display: flex; margin-top: 22px;"
                  >
                    <button
                      type="button"
                      @click="getcode"
                      style="border: 1px; margin: 0px auto; width: 100px; text-align: center; height: 42px; background: rgb(151, 6, 53); border-radius: 8px; color: rgb(255, 255, 255); font-size: 16px; cursor: pointer;"
                    >发送验证码</button>
                    <span
                      style="color: rgb(153, 153, 153); width: 200px; display: inline-block; margin-right: 163px;"
                    >我们将向您填写的手机号码发送验证短信，请注意查收</span>
                  </div>
                </li>
                <li class="wppb-form-field wppb-default-password">
                  <label for="passw1">
                    新密码
                    <span title="This field is required" class="wppb-required">*</span>
                  </label>
                  <input
                    name="passw1"
                    id="passw1"
                    maxlength="70"
                    type="password"
                    v-model="pwd"
                    autocomplete="off"
                    required="required"
                    class="text-input"
                  >
                </li>
                <li class="wppb-form-field wppb-default-repeat-password">
                  <label for="passw2">
                    确认密码
                    <span title="This field is required" class="wppb-required">*</span>
                  </label>
                  <input
                    name="passw2"
                    id="passw2"
                    maxlength="70"
                    type="password"
                    v-model="pwd1"
                    autocomplete="off"
                    required="required"
                    class="text-input"
                  >
                </li>
                <li  class="wppb-form-field wppb-recaptcha">
                  <div  class="wppb-recaptcha-element"></div>
                </li>
              </ul>
              <div>
              <p class="form-submit" style="text-align: center;">
                <input name="register" type="submit" @click.prevent="resetPwd"  value="重置" class="submit button">
              </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import ajax from "../ajax";
export default {
data(){

  return {
    encryption:'',
    phone:'',
    pwd:'',
    vcode:'',
    pwd1:''
  }
},
  methods:{
     getcode() {
       let mobile = this.phone;
       if (mobile) {
         ajax
           .postSendCode({ mobile, usage: "reset" })
           .then(res => {
           if (res.success) {
           this.encryption = res.data;
           alert("验证码发送成功，请注意查收！");
         } else {
           alert(res.message);
         }
       });
       } else {
         alert("请正确填写手机号码！");
         $("#mobile").focus();
       }

     },
     resetPwd(){
       if(this.pwd !== this.pwd1) {
         alert('输入的密码不一致')
         return;
       }
       ajax
         .postResetPassword({
           mobile: this.phone,
           password: this.pwd,
           vcode:this.vcode,
           encryption:this.encryption
         })
         .then(res => {
         if (res.success) {
         alert("修改成功");
         this.$router.push('/Login');
       } else {
         alert(res.message);
       }
     });
     }
  }
}
</script>










// WEBPACK FOOTER //
// src/components/Forgetpassword.vue